# frozen_string_literal: true

require_relative 'base'
require_relative 'blocks_hexes'

module Engine
  module Ability
    class BlocksHexesConsent < BlocksHexes
    end
  end
end
